import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
	Outlet,
	useLocation,
	useNavigate,
	useRouteLoaderData,
} from 'react-router-dom';
import TabNavigation from '../../../components/organisms/tab-navigation';
import Card from '../../../components/atoms/card';
import { IUser } from '../../../services/User.service';
import { HomeLoaderData } from '../../../types/homeLoaderData';

const Admin = () => {
	const { user } = useRouteLoaderData('home') as HomeLoaderData;
	const { t } = useTranslation();
	const location = useLocation();
	const navigate = useNavigate();

	const [options, setOptions] = useState<{ label: string; path: string }[]>(
		[]
	);

	useEffect(() => {
		const paths = [
			{
				label: t('admin.users.title'),
				path: '/admin/users',
			},
			{
				label: t('admin.contacts.title'),
				path: '/admin/contacts',
			},
			{
				label: t('admin.harbors.title'),
				path: '/admin/harbors',
			},
		];
		if (user.permissions.isSystemAdmin) {
			paths.push({
				label: t('admin.clients.title'),
				path: '/admin/clients',
			});
		}
		setOptions(paths);
	}, [user]);

	useEffect(() => {
		if (options.length == 0) return;
		if (location.pathname.split('/').length <= 2) navigate(options[0].path);
	}, [location, options]);

	return (
		<Card className="flex flex-col flex-grow">
			<TabNavigation options={options} />
			<Outlet />
		</Card>
	);
};

export default Admin;
